import { render, staticRenderFns } from "./wayTestD.vue?vue&type=template&id=6151328e&scoped=true&"
import script from "./wayTestD.vue?vue&type=script&lang=js&"
export * from "./wayTestD.vue?vue&type=script&lang=js&"
import style0 from "./wayTestD.vue?vue&type=style&index=0&id=6151328e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6151328e",
  null
  
)

export default component.exports